import request from "../request";

export const syncTerms = () =>
  request.post("setting/term/sync").then((res) => res);
export const getTerms = () =>
  request.get("setting/term").then((res) => res);

export const getTermActiveToday = () =>
  request.get("setting/term/active-today").then((res) => res);

export const createTerm = (data) =>
  request.post("setting/term", data).then((res) => res);

export const updateTerm = (id, data) =>
  request.put(`setting/term/${id}`, data).then((res) => res);

export const deleteTerm = (id) =>
  request.delete(`setting/term/${id}`).then((res) => res);
